var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mlrHomeDynamic"},[(_vm.tEntry === 'true')?_c('RewardsGreeting'):_vm._e(),(_vm.tEntry === 'false')?_c('RewardsGreetingNoTicket'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }